import { AxiosError } from 'axios';
import api from '../../../services/api';
import { useState, useEffect } from 'react';
import DocumentoAcessoExclusao from '../exclusao';
import { useAppSelector } from '../../../store/hooks';
import { tratarErroApi } from '../../../rxlib/services/utilitarios';
import { Listagem } from '../../../rxlib/components/layout/listagem';
import { ConfiguracoesTabela } from '../../../rxlib/components/table';
import { usuarioTemPermissao } from '../../../rxlib/services/seguranca';
import AcessoBloqueado from '../../../rxlib/components/acesso-bloqueado';
import { RxlibLayout } from '../../../rxlib/components/layout/rxlib-Layout';
import { ModalWarning } from '../../../rxlib/components/modal/modal-warning';
import { ApiError, DocumentoAcessoListagemProps } from '../../../services/tipos';
import Breadcrumb, { BreadcrumbItem } from '../../../rxlib/components/breadcrumb';

function DocumentoAcessoListagem(props: DocumentoAcessoListagemProps) {
    const [nomeUsuario, setNomeUsuario] = useState<string>('');
    const [carregando, setCarregando] = useState<boolean>(false);
    const [showWarning, setShowWarning] = useState<boolean>(false);
    const [token] = useState(useAppSelector(state => state.token));
    const [showExclusao, setShowExclusao] = useState<boolean>(false);
    const [messageWarning, setMessageWarning] = useState<string[]>([]);
    const [idDocumentoAcesso, setIdDocumentoAcesso] = useState<string>('');
    const [realizarConsulta, setRealizarConsulta] = useState<boolean>(true);
    const [documentosAcessoUsuario, setDocumentosAcessoUsuario] = useState<[{}]>([{}]);

    const handleHide = () => setShowWarning(false);

    const handleHideExclusao = () => setShowExclusao(false);

    const breadcrumbs: BreadcrumbItem[] = [
        { texto: 'Home', link: '/home' },
        { texto: 'Usuários', link: '/usuario' },
        { texto: 'Documentos acesso usuário', link: '' },
    ];

    const configuracoesTabela: ConfiguracoesTabela = {
        mensagemPadrao: 'Não foram encontrados resultados para a consulta.',
        colunas: [
            { nome: 'Documento', campo: 'Documento', tipo: 'string' },
        ],
    }

    const temPermissao = usuarioTemPermissao(token, 'documento_acesso_usuario_visualizar');
    const linkNovo = usuarioTemPermissao(token, 'documento_acesso_usuario_novo') ? `/usuario/documentoacesso/${props.match.params.idUsuario}/novo` : '';
    const linkEdicao = usuarioTemPermissao(token, 'documento_acesso_usuario_editar') ? `/usuario/documentoacesso/${props.match.params.idUsuario}/editar` : '';
    const handleExclusao = usuarioTemPermissao(token, 'documento_acesso_usuario_excluir') ? handleExcluir : undefined;

    useEffect(() => {
        if ((temPermissao) && (realizarConsulta)) {
            if (props.match.params.idUsuario) {
                setCarregando(true);
                Promise.all([
                    api.get(`/Usuario/${props.match.params.idUsuario}`),
                    api.get(`/OData/DocumentoAcessoUsuario?$filter=idUsuario eq ${props.match.params.idUsuario}`)
                ]).then(response => {
                    setTimeout(() => {
                        setDocumentosAcessoUsuario(response[1].data.value);
                        setNomeUsuario(response[0].data.nome);
                        setRealizarConsulta(false);
                        setCarregando(false);
                    }, 250);
                }).catch((error: AxiosError<ApiError>) => {
                    setCarregando(false);
                    setMessageWarning(tratarErroApi(error, 'Não foi possível realizar a consulta: '));
                    setShowWarning(true);
                });
            }
        }
    }, [props.match.params.idUsuario, temPermissao, realizarConsulta]);

    function handleExcluir(id: string) {
        setIdDocumentoAcesso(id);
        setShowExclusao(true);
    }

    function tratarErro(error: AxiosError<ApiError>, mensagem: string) {
        setCarregando(false);
        setMessageWarning(tratarErroApi(error, mensagem));
        setShowWarning(true);
    }

    return (
        <>
            <RxlibLayout>
                <Breadcrumb
                    itens={breadcrumbs} />
                <Listagem
                    campoId='Id'
                    linkNovo={linkNovo}
                    tipoBotaoAcao='button'
                    listagemDetalhe={false}
                    carregando={carregando}
                    linkEdicao={linkEdicao}
                    onExcluir={handleExclusao}
                    fonteDados={documentosAcessoUsuario}
                    configuracoesTabela={configuracoesTabela}
                    descricao={`Listagem de documentos para acesso do usuário: ${nomeUsuario}`}
                    linkVisualizacao={`/usuario/documentoacesso/${props.match.params.idUsuario}/visualizar`} />
                <ModalWarning
                    show={showWarning}
                    onHide={handleHide}
                    message={messageWarning} />
                <AcessoBloqueado
                    permissao={temPermissao} />
                <DocumentoAcessoExclusao
                    show={showExclusao}
                    tratarErro={tratarErro}
                    onHide={handleHideExclusao}
                    onExcluir={setRealizarConsulta}
                    idDocumentoAcesso={idDocumentoAcesso} />
            </RxlibLayout>
        </>
    );
}

export default DocumentoAcessoListagem;